import { clsx } from 'clsx';

import { ReactSelectValue } from 'types/forms';

interface SingleChoiceButtonsProps {
  options: ReactSelectValue<string>[] | undefined;
  selected: string;
  onSelect: (option: string) => void;
}

const SingleChoiceButtons = ({
  options,
  selected,
  onSelect,
}: SingleChoiceButtonsProps) => {
  return (
    <div className="flex gap-3">
      {options?.map((option) => {
        const isSelected = option.value === selected;

        return (
          <button
            key={option.value}
            className={clsx(
              'rounded-lg border px-4 py-3 text-center font-medium',
              isSelected
                ? 'border-primary-d-600 bg-primary-d-600 text-white'
                : 'border-gray-d-300 bg-white text-gray-d-900',
            )}
            onClick={() => onSelect(option.value)}
            type="button"
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default SingleChoiceButtons;
